// // import smoothscroll from 'smoothscroll-polyfill'
// //smoothscroll.polyfill()
//
// const arrowNodesP = document.getElementsByClassName('page-previews__arrow')
// const backNodesP = document.getElementsByClassName('page-previews__arrow-back')
// const pageNodes = document.getElementsByClassName('page-previews__list')
//
// // require('smoothscroll-polyfill').polyfill()
// // // import smoothscroll from 'smoothscroll-polyfill';
// // //smoothscroll.polyfill();
//
// let scrolledP = 0
//
// if (arrowNodesP.length > 0) {
//     const arrowsP = Array.from(arrowNodesP)
//     const backsP = Array.from(backNodesP)
//     const pages = Array.from(pageNodes)
//
//     arrowsP.map((arrow, key) => {
//         arrow.addEventListener('click', () => {
//             if (pages[key].scrollLeft + pages[key].offsetWidth < pages[key].scrollWidth) {
//                 scrolledP += 260
//             }
//
//             pages[key].scroll({
//                 top: 0,
//                 left: scrolledP,
//                 behavior: 'smooth'
//             })
//         })
//
//         arrow.addEventListener('keypress', (e) => {
//             if (e.charCode === 13) {
//                 if (pages[key].scrollLeft + pages[key].offsetWidth < pages[key].scrollWidth) {
//                     scrolledP += 260
//                 }
//
//                 pages[key].scroll({
//                     top: 0,
//                     left: scrolledP,
//                     behavior: 'smooth'
//                 })
//             }
//         })
//     })
//
//     backsP.map((arrow, key) => {
//         arrow.addEventListener('click', () => {
//             if (scrolledP > 0) {
//                 scrolledP -= 260
//             }
//
//             pages[key].scroll({
//                 top: 0,
//                 left: scrolledP,
//                 behavior: 'smooth'
//             })
//         })
//
//         arrow.addEventListener('keypress', (e) => {
//             if (e.charCode === 13) {
//                 if (scrolledP > 0) {
//                     scrolledP -= 260
//                 }
//
//                 pages[key].scroll({
//                     top: 0,
//                     left: scrolledP,
//                     behavior: 'smooth'
//                 })
//             }
//         })
//     })
// }





// import smoothscroll from 'smoothscroll-polyfill'
//smoothscroll.polyfill()
const pages = document.querySelectorAll('.page-previews__wrapper')
if (pages) {
    Array.from(pages)
        .forEach((children) => {
            if (children) {
                // console.log(scrolledP)
                const arrowLeft = children.getElementsByClassName('page-previews__arrow')
                const arrowRight = children.getElementsByClassName('page-previews__arrow-back')
                const nodes = children.getElementsByClassName('page-previews__list')
                // const groupNodes = children.getElementsByClassName('page-previews__group')

                if (arrowLeft.length > 0) {
                    let scrolledP = 0
                    const arrowsP = Array.from(arrowLeft)
                    const backsP = Array.from(arrowRight)
                    const pages = Array.from(nodes)
                    // console.log(pages.length)
                    // const groups = Array.from(groupNodes)

                    arrowsP.map((arrow, key) => {
                        // console.log(pages[key].offsetWidth)
                        // console.log(pages[key].scrollWidth)
                        // console.log(groups[key].offsetWidth)
                        // console.log(groups[key].scrollWidth)
                        console.log(pages[key].offsetWidth);

                        arrow.addEventListener('click', () => {
                            if (pages[key].offsetWidth < pages[key].scrollWidth) {
                                scrolledP += 260
                            }

                            pages[key].scroll({
                                top: 0,
                                left: scrolledP,
                                behavior: 'smooth'
                            })
                            console.log(scrolledP)
                            console.log(pages[key].offsetWidth)
                            console.log(pages[key].scrollWidth)
                            if (scrolledP + pages[key].offsetWidth >= pages[key].scrollWidth) {
                                arrow.classList.add('end')
                            }
                            if (scrolledP != 0) {
                                arrowRight[0].classList.remove('end')
                            }

                            // console.log(scrolledP)
                            // console.log(pages[key].offsetWidth)
                            // console.log(pages[key].scrollWidth)
                            // console.log(groups[key].offsetWidth)
                            // console.log(groups[key].scrollWidth)
                        })

                        arrow.addEventListener('keyup', (e) => {
                            e = e || window.KeyboardEvent
                            if (e.key === 'ArrowRight') {
                                // console.log("yes")
                                if (pages[key].offsetWidth < pages[key].scrollWidth) {
                                    scrolledP += 260
                                }

                                pages[key].scroll({
                                    top: 0,
                                    left: scrolledP,
                                    behavior: 'smooth'
                                })
                                if (scrolledP + pages[key].offsetWidth >= pages[key].scrollWidth) {
                                    arrow.classList.add('end')
                                }
                                if (scrolledP != 0) {
                                    arrowRight[0].classList.remove('end')
                                }
                            }
                        })
                    })

                    backsP.map((arrow, key) => {
                        arrow.addEventListener('click', () => {
                            if (scrolledP > 0) {
                                scrolledP -= 260
                            }

                            pages[key].scroll({
                                top: 0,
                                left: scrolledP,
                                behavior: 'smooth'
                            })

                            if (scrolledP == 0) {
                                arrow.classList.add('end')
                            }
                            arrowLeft[0].classList.remove('end')
                        })

                        arrow.addEventListener('keyup', (e) => {
                            e = e || window.KeyboardEvent
                            if (e.key === 'ArrowLeft') {
                                if (scrolledP > 0) {
                                    scrolledP -= 260
                                }

                                pages[key].scroll({
                                    top: 0,
                                    left: scrolledP,
                                    behavior: 'smooth'
                                })

                                if (scrolledP == 0) {
                                    arrow.classList.add('end')
                                }
                                arrowLeft[0].classList.remove('end')
                            }
                        })
                    })
                }
            }
        })
}